
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";
import { ScrollArea } from "@/components/ui/scroll-area";
import { JournalFormFields } from "./form/JournalFormFields";
import { JournalFormActions } from "./form/JournalFormActions";
import { useJournalForm } from "./form/useJournalForm";

interface JournalFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const JournalForm = ({ open, onOpenChange }: JournalFormProps) => {
  const { form, isLoading, onSubmit } = useJournalForm(onOpenChange);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] w-[95vw] sm:w-full h-[90vh]">
        <DialogHeader>
          <DialogTitle>Journal de santé</DialogTitle>
          <DialogDescription>
            Enregistrez votre état de santé quotidien
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
              <JournalFormFields form={form} />
              <JournalFormActions
                onCancel={() => onOpenChange(false)}
                isLoading={isLoading}
              />
            </form>
          </Form>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
